export default __webpack_public_path__ + "0cef6a6c0598aa64fd4a0a2f0ca8e6e9.svg";